import { getFlats } from '../../../api'
import { getItemsFromIdwellApiResponse } from '../../../utils/api'
import { InputAsyncSelect, InputSelectControl } from '../../Select'

import { toFlatSelectItems } from './FlatSelect.utils'

import FlatIcon from '../../../icons/flat.svg'

function FlatSelect({
  Control = InputSelectControl,
  getData = getFlats,
  getDataItems = getItemsFromIdwellApiResponse,
  toPreparedItems = toFlatSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      EntityIcon={FlatIcon}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default FlatSelect
